module.exports = __webpack_public_path__ + "static/media/halfcircle_pink.ffc7305b.jpg";